import React, {FC} from "react";
import classNames from "classnames";
import type {StepperState, StepperStepState} from "./helpers/deriveStepperState";

const css = require("./MolliePaymentSection.less");

// Phase 23 / Plan 23-05 / BDSEC-03 — 4-Schritt-Stepper.
// Steps: Erstellt → Methode gewählt → Bezahlt → Abgerechnet
// CSS-Klassen + HTML-Struktur 1:1 aus Sketch Variant D
// (`mollie-status-and-actions.md` Z.59-90, 122-149).

export type AttemptStepperProps = {
    state: StepperState;
    labels?: Partial<Record<keyof StepperState, string>>;
};

// Marker-Char pro Zustand. Sketch-Findings: ✓ done / ● active / ✕ error / ⌛ expired.
function markerFor(stepState: StepperStepState): string {
    switch (stepState) {
        case "done":
            return "✓";
        case "active":
            return "●";
        case "error":
            return "✕";
        case "expired":
            return "⌛";
        case "pending":
        default:
            return "";
    }
}

interface StepLabelPair {
    key: keyof StepperState;
    label: string;
}

const STEP_ORDER: ReadonlyArray<StepLabelPair> = [
    {key: "created", label: "Erstellt"},
    {key: "method", label: "Methode gewählt"},
    {key: "paid", label: "Bezahlt"},
    {key: "settled", label: "Abgerechnet"},
];

export const AttemptStepper: FC<AttemptStepperProps> = ({state, labels}) => {
    return (
        <ol className={css.stepperRow} data-testid="attempt-stepper">
            {STEP_ORDER.map(({key, label}) => {
                const stepState = state[key];
                const overrideLabel = labels ? labels[key] : undefined;
                const resolvedLabel = overrideLabel || label;
                return (
                    <li
                        key={key}
                        className={classNames(css.timelineStep, css[stepState])}
                        data-testid={`stepper-step-${key}`}
                        data-step-state={stepState}
                    >
                        <span className={css.timelineStepDot} aria-hidden="true">
                            {markerFor(stepState)}
                        </span>
                        <span className={css.timelineStepLabel}>{resolvedLabel}</span>
                    </li>
                );
            })}
        </ol>
    );
};

export default AttemptStepper;
